import resources from "scripts/resources";
import { Patterns } from "scripts/settings";

export default {
	email: [{ pattern: Patterns.email, message: resources.patterns }],
	required: [{ required: true }],
};
